module.exports = __webpack_public_path__ + "static/birdcatcher-c7ff9dff04a11681bb07c478d245057c.jpg";